import { Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { debouncedSearch } from 'shared/utils/rx-operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { CustomerModel } from '../../../../customer/customer.model';

@Component({
  selector: 'app-nacha-customer-selector-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatRadioModule],
  templateUrl: './customer-selector-modal.component.html',
})
export class NachaCustomerSelectorModalComponent implements OnInit {
  @Input() data: any;

  selectedCustomer: CustomerModel | null = null;
  searchTerm = ''; // Bound to the input for display
  filterTerm = ''; // Debounced value the filter reads
  searchTerm$ = new Subject<string>();
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.searchTerm$
      .pipe(debouncedSearch(), takeUntilDestroyed(this.destroyRef))
      .subscribe((v) => (this.filterTerm = v));
  }

  get filteredCustomers(): CustomerModel[] {
    const allCustomers: CustomerModel[] = this.data?.data?.customers || [];
    const search = this.filterTerm.toLowerCase().trim();
    if (!search) return allCustomers;
    return allCustomers.filter((c) => {
      const displayName = c.displayName?.toLowerCase() ?? '';
      const companyName = c.companyName?.toLowerCase() ?? '';
      const accountNumber = c.companyAccountNumber?.toLowerCase() ?? '';
      return displayName.includes(search) || companyName.includes(search) || accountNumber.includes(search);
    });
  }

  isValidSelection(): boolean {
    return this.selectedCustomer !== null;
  }
}
